// Apple-style Rewards/Preroll Section Animations

class RewardsAnimations {
  constructor() {
    this.section = null;
    this.isMobile = this.checkMobile();
    this.init();
  }

  checkMobile() {
    return window.innerWidth <= 749;
  }

  init() {
    this.section = document.querySelector('.rewards-program');
    if (!this.section) return;

    // On mobile, simpler animations
    if (this.isMobile) {
      this.initMobileAnimations();
      return;
    }

    // Wait for GSAP and ScrollTrigger
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(() => this.init(), 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Initialize animations
    this.animateImage();
    this.animateTextBox();
    this.animateContent();
  }

  initMobileAnimations() {
    const elements = [
      this.section.querySelector('.rewards-program__image-wrapper'),
      this.section.querySelector('.rewards-program__text-wrapper'),
      this.section.querySelector('.rewards-program__heading'),
      this.section.querySelector('.rewards-program__subheading'),
      this.section.querySelector('.rewards-program__description'),
      this.section.querySelector('.rewards-program__button'),
    ];

    elements.forEach(el => {
      if (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      }
    });
  }

  animateImage() {
    const imageWrapper = this.section.querySelector('.rewards-program__image-wrapper');
    const image = this.section.querySelector('.rewards-program__image img');
    if (!imageWrapper) return;

    // Set initial state
    gsap.set(imageWrapper, {
      opacity: 0,
      x: -60,
      scale: 0.9,
    });

    // Fade in and slide
    gsap.to(imageWrapper, {
      opacity: 1,
      x: 0,
      scale: 1,
      duration: 1.2,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: imageWrapper,
        start: 'top 75%',
        toggleActions: 'play none none reverse',
      },
    });

    // Parallax effect
    if (image) {
      gsap.to(image, {
        y: -30,
        scale: 1.1,
        ease: 'none',
        scrollTrigger: {
          trigger: imageWrapper,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5,
        },
      });
    }
  }

  animateTextBox() {
    const textWrapper = this.section.querySelector('.rewards-program__text-wrapper');
    if (!textWrapper) return;

    // Set initial state
    gsap.set(textWrapper, {
      opacity: 0,
      x: 60,
      scale: 0.95,
    });

    // Smooth reveal
    gsap.to(textWrapper, {
      opacity: 1,
      x: 0,
      scale: 1,
      duration: 1.2,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: textWrapper,
        start: 'top 75%',
        toggleActions: 'play none none reverse',
      },
    });
  }

  animateContent() {
    const heading = this.section.querySelector('.rewards-program__heading');
    const subheading = this.section.querySelector('.rewards-program__subheading');
    const description = this.section.querySelector('.rewards-program__description');
    const button = this.section.querySelector('.rewards-program__button');

    const elements = [heading, subheading, description, button].filter(Boolean);

    elements.forEach((el, index) => {
      gsap.set(el, {
        opacity: 0,
        y: 20,
      });

      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.3 + (index * 0.1),
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      });
    });

    // Button hover animation
    if (button) {
      button.addEventListener('mouseenter', () => {
        gsap.to(button, {
          scale: 1.05,
          duration: 0.3,
          ease: 'power2.out',
        });
      });

      button.addEventListener('mouseleave', () => {
        gsap.to(button, {
          scale: 1,
          duration: 0.3,
          ease: 'power2.out',
        });
      });
    }
  }
}

// Initialize
function waitForGSAP(callback, maxAttempts = 50) {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    callback();
  } else if (maxAttempts > 0) {
    setTimeout(() => waitForGSAP(callback, maxAttempts - 1), 100);
  }
}

function initRewardsAnimations() {
  const rewardsSection = document.querySelector('.rewards-program');
  if (rewardsSection) {
    new RewardsAnimations();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    waitForGSAP(initRewardsAnimations);
  });
} else {
  waitForGSAP(initRewardsAnimations);
}

